function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 32.001,
  cy: 28.253,
  fill: "#00d8ff",
  fillRule: "nonzero",
  r: 5.971
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#00d8ff",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "m32.0009866 16.1144024c8.0150455 0 15.4618159 1.1503622 21.0755048 3.0821026 6.7640512 2.328349 10.9235086 5.8583629 10.9235086 9.0549099 0 3.3307229-4.4080777 7.0817327-11.6713427 9.4870356-5.4913519 1.8192693-12.7190997 2.7703407-20.3276707 2.7703407-7.8019424 0-15.1875443-.8918761-20.7420379-2.7900725-7.02648377-2.4013566-11.2589487-6.1997225-11.2589487-9.4673038 0-3.1708957 3.97200555-6.6732851 10.6413442-8.9976877 5.6353939-1.9633113 13.2656698-3.1393248 21.3596424-3.1393248z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.4346231 22.2194124c4.0035764-6.9436103 8.7214429-12.81973177 13.2005549-16.71675659 5.3966395-4.69616156 10.5328195-6.53516264 13.301187-4.93886234 2.884785 1.66338831 3.932542 7.35600431 2.3875444 14.85210423-1.1681209 5.6669647-3.954247 12.4014182-7.7565593 18.993803-3.8970248 6.7581316-8.3603515 12.711207-12.7782951 16.5746878-5.5900108 4.8875597-10.9965161 6.6555264-13.8260521 5.023709-2.7466625-1.5844613-3.7963928-6.7739171-2.4802836-13.713581 1.1128719-5.8682288 3.9068907-13.0644058 7.9519038-20.0751041z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.444489 34.4235129c-4.0154155-6.9376908-6.750239-13.958255-7.8907353-19.785047-1.3733313-7.02056422-.4025282-12.38957917 2.3638662-13.98982582 2.8828117-1.66930784 8.3366733.26637891 14.058887 5.34731001 4.3271774 3.84177586 8.7687991 9.61923851 12.5809773 16.20570371 3.9088639 6.7522121 6.8390319 13.591244 7.9775551 19.3470017 1.4423925 7.2849699.2742716 12.8513026-2.5532912 14.4870664-2.7446894 1.5884076-7.764452-.0927393-13.1196547-4.7001079-4.5225219-3.8930784-9.3627254-9.9073223-13.4176044-16.9121011z"
})));

function SvgIconReact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 61,
    viewBox: "0 0 68 61",
    width: 68,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReact);
export default __webpack_public_path__ + "static/media/icon-react.ffa8f55f.svg";
export { ForwardRef as ReactComponent };